// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"b5882c54","198":"6242f535","409":"5cbff11e","689":"aaa192f3"}[chunkId] + ".chunk.js";
};